// Pure derivations over the Counseling Manual category tree (영역 → 하위영역 →
// 항목). Used by the cascading select, the filter bar, and the Category Manager.
// Mirrors the prototype helpers getAreas / getSubAreas / getItems in
// prototype/pages/consultation-manual.html.

import type { ManualCategoryTree } from '../types/counseling-manual.types';

export function getAreas(tree: ManualCategoryTree): string[] {
  return tree.areas.map((a) => a.name).filter(Boolean);
}

export function getSubAreas(tree: ManualCategoryTree, area: string): string[] {
  if (!area) return [];
  const found = tree.areas.find((a) => a.name === area);
  return found ? found.subAreas.map((s) => s.name).filter(Boolean) : [];
}

export function getItems(
  tree: ManualCategoryTree,
  area: string,
  subArea: string,
): string[] {
  if (!area || !subArea) return [];
  const foundArea = tree.areas.find((a) => a.name === area);
  const foundSub = foundArea?.subAreas.find((s) => s.name === subArea);
  return foundSub ? foundSub.items.slice() : [];
}
